import { render, staticRenderFns } from "./BrickAndSubstructurePrintPage1.vue?vue&type=template&id=6817d1b8"
import script from "./BrickAndSubstructurePrintPage1.vue?vue&type=script&lang=js"
export * from "./BrickAndSubstructurePrintPage1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports